// extracted by mini-css-extract-plugin
export default {"icon":"Icon__icon___GiqOj","active":"Icon__active___kBJiz","invert":"Icon__invert___wtZP_","text_icon":"Icon__text_icon___UlTw0"};